// Centered modal confirmation. Resolves true when the user accepts, false
// otherwise. Called directly from JS (e.g. the link/hashtag action menu) and
// wired into Turbo's form confirmation in application.js, so every
// data-turbo-confirm form gets the same dialog. Pass linkUrl/linkLabel to show
// a clickable pointer (e.g. to the relevant mute settings page).
export function confirmDialog({ title, body, accept, cancel, linkUrl, linkLabel } = {}) {
  return new Promise((resolve) => {
    const overlay = document.createElement("div")
    overlay.className = "fixed inset-0 z-[60] flex items-center justify-center bg-zinc-900/40 p-4"

    const card = document.createElement("div")
    card.className = "bg-white rounded-xl shadow-xl w-full max-w-md p-5"
    card.setAttribute("role", "alertdialog")
    card.setAttribute("aria-modal", "true")

    const heading = document.createElement("h2")
    heading.className = "text-base font-semibold text-zinc-900"
    heading.textContent = title || "Are you sure?"

    const text = document.createElement("p")
    text.className = "text-sm text-zinc-600 mt-2 leading-relaxed"
    text.textContent = body || ""

    card.append(heading, text)

    if (linkUrl && linkLabel) {
      const link = document.createElement("a")
      link.href = linkUrl
      link.textContent = linkLabel
      link.className = "inline-block text-sm text-blue-600 hover:text-blue-700 underline underline-offset-2 mt-2"
      card.appendChild(link)
    }

    const actions = document.createElement("div")
    actions.className = "flex justify-end gap-2 mt-5"

    const cancelButton = document.createElement("button")
    cancelButton.type = "button"
    cancelButton.className = "text-sm font-medium text-zinc-700 bg-white border border-zinc-300 hover:bg-zinc-50 px-3 py-1.5 rounded cursor-pointer"
    cancelButton.textContent = cancel || "Cancel"

    const acceptButton = document.createElement("button")
    acceptButton.type = "button"
    acceptButton.className = "text-sm font-medium text-white bg-zinc-900 hover:bg-zinc-800 px-3 py-1.5 rounded cursor-pointer"
    acceptButton.textContent = accept || "Confirm"

    actions.append(cancelButton, acceptButton)
    card.appendChild(actions)
    overlay.appendChild(card)
    document.body.appendChild(overlay)
    acceptButton.focus()

    const finish = (result) => {
      document.removeEventListener("keydown", onKeydown, true)
      overlay.remove()
      resolve(result)
    }

    const onKeydown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault()
        finish(false)
      }
    }

    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) finish(false)
    })
    cancelButton.addEventListener("click", () => finish(false))
    acceptButton.addEventListener("click", () => finish(true))
    document.addEventListener("keydown", onKeydown, true)
  })
}
